import config from '@/../service/project.config';
import axios from 'axios';
import { ITranslationsApi } from '@/types/translationsTypes';

export default {
  async getTranslationsByLocationCode(locationCode: string): Promise<ITranslationsApi> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/translations/${locationCode}`;

    return axios.get(endpointUrl).then((response) => {
      return response.data as ITranslationsApi;
    });
  },

  async getUserTranslations(): Promise<ITranslationsApi> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/translations/user-translations`;

    return axios.get(endpointUrl).then((response) => {
      return response.data as ITranslationsApi;
    });
  },
};
